// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UklKDHZZ{flex:1}`, "",{"version":3,"sources":["webpack://./src/components/WebAppContainer/styles.module.scss"],"names":[],"mappings":"AAAA,UACE,MAAA","sourcesContent":[".wrapper {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `UklKDHZZ`
};
export default ___CSS_LOADER_EXPORT___;
